/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, useState, type ReactNode } from 'react';

interface ShareTargetContextValue {
  pendingShareUrl: string | null;
  setPendingShareUrl: (url: string) => void;
  clearPendingShareUrl: () => void;
}

const ShareTargetContext = createContext<ShareTargetContextValue | null>(null);

export function ShareTargetProvider({ children }: { children: ReactNode }) {
  const [pendingShareUrl, setPendingShareUrl] = useState<string | null>(null);

  return (
    <ShareTargetContext.Provider
      value={{
        pendingShareUrl,
        setPendingShareUrl,
        clearPendingShareUrl: () => setPendingShareUrl(null),
      }}
    >
      {children}
    </ShareTargetContext.Provider>
  );
}

export function useShareTargetContext(): ShareTargetContextValue {
  const ctx = useContext(ShareTargetContext);
  if (!ctx) throw new Error('useShareTargetContext must be used within ShareTargetProvider');
  return ctx;
}
